import { Observable, from } from 'rxjs';

import { environment } from '@/environments/environment';

import { UserType } from '@authuser/user.types';

export class AuthUtils
{
    constructor()
    {
    }
    public static set idtoken(value: string)
    {
        localStorage.setItem('_it', value);
    }
    public static get idtoken(): string
    {
        return localStorage.getItem('_it') ?? '';
    }

    public static set token(value: string)
    {
        localStorage.setItem('access_token', value);
    }
    public static get token(): string
    {
        return localStorage.getItem('access_token') ?? '';
    }

    public static set refreshToken(value: string)
    {
        localStorage.setItem('_rt', value);
    }
    public static get refreshToken(): string
    {
        return localStorage.getItem('_rt') ?? '';
    }
    public static set instanceId(value: string)
    {
        localStorage.setItem('_ix', value);
    }
    public static get instanceId(): string
    {
        return localStorage.getItem('_ix') ?? '';
    }
    public static set instanceCode(value: string)
    {
        localStorage.setItem('instancecode', value);
    }
    public static get instanceCode(): string
    {
        return localStorage.getItem('instancecode') ?? '';
    }
    public static set hostingLocation(value: string)
    {
        localStorage.setItem('_hl', value);
    }
    public static get hostingLocation(): string
    {
        return localStorage.getItem('_hl') ?? '';
    }
    public static set timezoneName(value: string) {
        localStorage.setItem('_timezonename', value);
    }
    public static get timezoneName(): string {
        return localStorage.getItem('_timezonename') ?? '';
    }

    public static get user(): UserType | null
    {
        const user = localStorage.getItem('_ud') ?? '';

        return user ? JSON.parse(user) : null;
    }

    public static isTokenExpired(token: string, offsetSeconds?: number): boolean
    {
        if ( !token || token === '' )
        {
            return true;
        }

        const date = this._getTokenExpirationDate(token);

        offsetSeconds = offsetSeconds || 0;

        if ( date === null )
        {
            return true;
        }

        return !(date.valueOf() > new Date().valueOf() + offsetSeconds * 1000);
    }

    public static clearLocalStorage() {
        localStorage.removeItem('_at');
        localStorage.removeItem('_it');
        localStorage.removeItem('_rt');
        //localStorage.removeItem('_ic');
        //localStorage.removeItem('_ix');
        localStorage.removeItem('_hl');
        localStorage.removeItem('_ud');
    }

    private static _b64decode(str: string): string
    {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        let output = '';

        str = String(str).replace(/=+$/, '');

        if ( str.length % 4 === 1 )
        {
            throw new Error(
                '\'atob\' failed: The string to be decoded is not correctly encoded.'
            );
        }

        /* eslint-disable */
        for (
            // initialize result and counters
            let bc = 0, bs: any, buffer: any, idx = 0;
            // get next character
            (buffer = str.charAt(idx++));
            // character found in table? initialize bit storage and add its ascii value;
            ~buffer &&
            (
                (bs = bc % 4 ? bs * 64 + buffer : buffer),
                    // and if not first of each 4 characters,
                    // convert the first 8 bits to one ascii character
                bc++ % 4
            )
                ? (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
                : 0
        )
        {
            // try to find character in table (0-63, not found => -1)
            buffer = chars.indexOf(buffer);
        }
        /* eslint-enable */

        return output;
    }

    private static _b64DecodeUnicode(str: any): string
    {
        return decodeURIComponent(
            Array.prototype.map
                 .call(this._b64decode(str), (c: any) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                 .join('')
        );
    }

    private static _urlBase64Decode(str: string): string
    {
        let output = str.replace(/-/g, '+').replace(/_/g, '/');
        switch ( output.length % 4 )
        {
            case 0:
            {
                break;
            }
            case 2:
            {
                output += '==';
                break;
            }
            case 3:
            {
                output += '=';
                break;
            }
            default:
            {
                throw Error('Illegal base64url string!');
            }
        }
        return this._b64DecodeUnicode(output);
    }

    private static _decodeToken(token: string): any
    {
        // Return if there is no token
        if ( !token )
        {
            return null;
        }

        // Split the token
        const parts = token.split('.');

        if ( parts.length !== 3 )
        {
            throw new Error('The inspected token doesn\'t appear to be a JWT. Check to make sure it has three parts and see https://jwt.io for more.');
        }

        // Decode the token using the Base64 decoder
        const decoded = this._urlBase64Decode(parts[1]);

        if ( !decoded )
        {
            throw new Error('Cannot decode the token.');
        }

        return JSON.parse(decoded);
    }

    private static _getTokenExpirationDate(token: string): Date | null
    {
        // Get the decoded token
        const decodedToken = this._decodeToken(token);

        // Return if the decodedToken doesn't have an 'exp' field
        if ( !decodedToken.hasOwnProperty('exp') )
        {
            return null;
        }

        // Convert the expiration date
        const date = new Date(0);
        date.setUTCSeconds(decodedToken.exp);

        return date;
    }

    public static getTokenInstanceRoles(token: string): any[] | null
    {
        if ( !token || token === '' )
        {
            return null;
        }

        const decodedToken = this._decodeToken(token);
        if ( !decodedToken.hasOwnProperty('instance_roles') )
        {
            return null;
        }

        var json = decodedToken.instance_roles.replace(/"([^"]+)":/g, ($0: any, $1: any) => { return ('"' + $1[0].toLowerCase() + $1.slice(1) +  '":'); });

        const roles = JSON.parse(json);

        return roles;
    }

    //public static getIdentityToken(queryParams: any): Observable<any> {
    //    var p = new Promise((resolve, reject) => {
    //        fetch(environment.authority + '/connect/token', {
    //            method: 'post',
    //            headers: {
    //                'Accept': 'application/json, text/plain, */*',
    //                'Cache-Control': 'no-cache',
    //                'Content-Type': 'application/x-www-form-urlencoded'
    //            },
    //            body: AuthUtils.toQueryString(queryParams),
    //        })
    //        .then((response) => {

    //            console.warn(response);

    //            if (response.ok) {
    //                resolve(response.json());
    //            } else {
    //                reject(response['error']);
    //            }
    //        });
    //    });

    //    return from(p);
    //}

    public static getIdentityToken(queryParams: any): Observable<any> {
        return from(new Promise((resolve, reject) => {
            fetch(
                environment.authority + '/connect/token', {
                method: 'post',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Cache-Control': 'no-cache',
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: AuthUtils.toQueryString(queryParams)
            })
            .then((response: any) => {
                if (!response.ok) {
                    //throw new Error('Network response was not ok');
                    //reject(response['error']);
                    //reject(`HTTP Response Code: ${response?.status}`);
                    //throw new Error(`HTTP Response Code: ${response?.status}`);

                    reject(new Error(response['error'] ? response['error'] : `An error has occured : ${response?.status}`));
                }
                
                return response.json();
            })
            .then(data => {
                resolve(data);
            })
            .catch(e => {
                // Handle any errors that occurred during the fetch
                console.error(e);

                reject(e);
              });
        }));
    }

    ////

    public static toQueryString(queryParams: any) {
        let encodedQueryParams = [];

        for (let key in queryParams) {
            encodedQueryParams.push(key + "=" + encodeURIComponent(queryParams[key]));
        }

        return encodedQueryParams.join("&");
    }

    // Converts decimal to hex equivalent
    // (From ADAL.js: https://github.com/AzureAD/azure-activedirectory-library-for-js/blob/dev/lib/adal.js)
    public static _decimalToHex(number: number): string {
        var hex = number.toString(16);

        while (hex.length < 2) {
            hex = "0" + hex;
        }

        return hex;
    }

    // Generates RFC4122 version 4 guid (128 bits)
    // (From ADAL.js: https://github.com/AzureAD/azure-activedirectory-library-for-js/blob/dev/lib/adal.js)
    public static _guid() {
        // RFC4122: The version 4 UUID is meant for generating UUIDs from truly-random or
        // pseudo-random numbers.
        // The algorithm is as follows:
        //     Set the two most significant bits (bits 6 and 7) of the
        //        clock_seq_hi_and_reserved to zero and one, respectively.
        //     Set the four most significant bits (bits 12 through 15) of the
        //        time_hi_and_version field to the 4-bit version number from
        //        Section 4.1.3. Version4
        //     Set all the other bits to randomly (or pseudo-randomly) chosen
        //     values.
        // UUID                   = time-low "-" time-mid "-"time-high-and-version "-"clock-seq-reserved and low(2hexOctet)"-" node
        // time-low               = 4hexOctet
        // time-mid               = 2hexOctet
        // time-high-and-version  = 2hexOctet
        // clock-seq-and-reserved = hexOctet:
        // clock-seq-low          = hexOctet
        // node                   = 6hexOctet
        // Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
        // y could be 1000, 1001, 1010, 1011 since most significant two bits needs to be 10
        // y values are 8, 9, A, B

        var cryptoObj = window.crypto;

        if (cryptoObj && cryptoObj.getRandomValues) {
            var buffer = new Uint8Array(16);

            cryptoObj.getRandomValues(buffer);

            //buffer[6] and buffer[7] represents the time_hi_and_version field. We will set the four most significant bits (4 through 7) of buffer[6] to represent decimal number 4 (UUID version number).
            buffer[6] |= 0x40; //buffer[6] | 01000000 will set the 6 bit to 1.
            buffer[6] &= 0x4f; //buffer[6] & 01001111 will set the 4, 5, and 7 bit to 0 such that bits 4-7 == 0100 = "4".

            //buffer[8] represents the clock_seq_hi_and_reserved field. We will set the two most significant bits (6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively.
            buffer[8] |= 0x80; //buffer[8] | 10000000 will set the 7 bit to 1.
            buffer[8] &= 0xbf; //buffer[8] & 10111111 will set the 6 bit to 0.

            return (
                this._decimalToHex(buffer[0]) +
                this._decimalToHex(buffer[1]) +
                this._decimalToHex(buffer[2]) +
                this._decimalToHex(buffer[3]) +
                "-" +
                this._decimalToHex(buffer[4]) +
                this._decimalToHex(buffer[5]) +
                "-" +
                this._decimalToHex(buffer[6]) +
                this._decimalToHex(buffer[7]) +
                "-" +
                this._decimalToHex(buffer[8]) +
                this._decimalToHex(buffer[9]) +
                "-" +
                this._decimalToHex(buffer[10]) +
                this._decimalToHex(buffer[11]) +
                this._decimalToHex(buffer[12]) +
                this._decimalToHex(buffer[13]) +
                this._decimalToHex(buffer[14]) +
                this._decimalToHex(buffer[15])
            );
        } else {
            var guidHolder = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
            var hex = "0123456789abcdef";
            var r = 0;
            var guidResponse = "";

            for (var i = 0; i < 36; i++) {
                if (guidHolder[i] !== "-" && guidHolder[i] !== "4") {
                    // each x and y needs to be random
                    r = (Math.random() * 16) | 0;
                }
                if (guidHolder[i] === "x") {
                    guidResponse += hex[r];
                } else if (guidHolder[i] === "y") {
                    // clock-seq-and-reserved first hex is filtered and remaining hex values are random
                    r &= 0x3; // bit and with 0011 to set pos 2 to zero ?0??
                    r |= 0x8; // set pos 3 to 1 as 1???

                    guidResponse += hex[r];
                } else {
                    guidResponse += guidHolder[i];
                }
            }

            return guidResponse;
        }
    }

    public static _sha256(plain: any) {
        const encoder = new TextEncoder();
        const data = encoder.encode(plain);

        return window.crypto.subtle.digest("SHA-256", data);
    }

    public static _base64urlencode(str: any) {
        // Convert the ArrayBuffer to string using Uint8 array to convert to what btoa accepts.
        // btoa accepts chars only within ascii 0-255 and base64 encodes them.
        // Then convert the base64 encoded to base64url encoded
        //   (replace + with -, replace / with _, trim trailing =)
        return btoa(String.fromCharCode.apply(null, new Uint8Array(str) as any))
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
            .replace(/=+$/, "");
    }
}
